/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    // Bind handlers once so add/removeEventListener works reliably
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler = this.cartRefreshHandler.bind(this);
    this.initUpsells = this.initUpsells.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.initUpsells();
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.initUpsells();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    const form = this.querySelector('cart-form');
    if (form) form.refresh();
  }

  /**
   * Bind click handlers for cart drawer upsell "Add" buttons.
   * Buttons should have: data-upsell-add + data-variant-id
   */
  initUpsells() {
    const buttons = this.querySelectorAll('[data-upsell-add][data-variant-id]');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      // Prevent double-binding after merge refreshes
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', async () => {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.disabled = true;
        btn.classList.add('is-loading');

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: Number(variantId),
              quantity: 1,
            }),
          });

          if (!res.ok) throw new Error('Add to cart failed');

          // Use existing theme refresh pipeline
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } catch (err) {
          console.error('[CartDrawer Upsells] Add failed:', err);
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    const form = this.querySelector('cart-form');
    if (form) form.refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
